import Empty from "components/Empty";
import { Button, Center } from "@chakra-ui/react";
import { Link, useRouteError, useSearchParams } from "react-router-dom";
import { contractsPath } from "constants/paths";

type UnauthorizedErrorData = {
  feature?: string;
  returnTo?: string;
  buttonText?: string;
};

export class UnauthorizedError extends Error {
  data!: UnauthorizedErrorData;
  constructor(message: string, data: UnauthorizedErrorData) {
    super(message);
    this.data = data;
  }
}

const Unauthorized = () => {
  const error = useRouteError();
  const [searchParams] = useSearchParams();

  let feature = "the correct";
  let returnTo = `/${contractsPath}`;
  let buttonText = "Return to Contracts";

  if (error instanceof UnauthorizedError) {
    feature = error.data.feature ?? feature;
    returnTo = error.data.returnTo ?? returnTo;
    buttonText = error.data.buttonText ?? buttonText;
  }

  return (
    <Empty
      title="Unauthorized Access"
      message={`You do not have ${feature} permissions for the selected SAP customer code.`}
      maxWidth="400px"
      paddingTop={20}
    >
      <Center w="100%">
        <Button
          as={Link}
          to={searchParams ? `${returnTo}?${searchParams}` : returnTo}
        >
          {buttonText}
        </Button>
      </Center>
    </Empty>
  );
};

export default Unauthorized;
